/** Canopy neighbor tree in row detail. true in test; false in production until launch. */
export const isCanopyEnabled = process.env.REACT_APP_SHOW_CANOPY === 'true';
